// Mock Diet Plans Data
// Extracted from MealPlanner.tsx

export interface DietPlan {
  id: string;
  name: string;
  description: string;
  type: 'keto' | 'mediterranean' | 'paleo' | 'vegan' | 'low_carb' | 'diabetic' | 'custom';
  daily_targets: {
    calories: number;
    protein_percent: number;
    carbs_percent: number;
    fat_percent: number;
  };
  restrictions: string[];
  recommended_recipes: string[];
  guru_id?: string;
  duration_weeks?: number;
}

export const mockDietPlans: DietPlan[] = [
  {
    id: '1',
    name: 'Mediterranean Lifestyle',
    description: 'Heart-healthy eating pattern based on traditional Mediterranean cuisine',
    type: 'mediterranean',
    daily_targets: {
      calories: 2000,
      protein_percent: 20,
      carbs_percent: 50,
      fat_percent: 30
    },
    restrictions: ['processed foods', 'refined sugars'],
    recommended_recipes: ['1'],
    guru_id: 'guru1',
    duration_weeks: 12
  },
  {
    id: '2',
    name: 'Keto Transformation',
    description: 'Low-carb, high-fat diet for weight loss and metabolic health',
    type: 'keto',
    daily_targets: {
      calories: 1800,
      protein_percent: 25,
      carbs_percent: 10,
      fat_percent: 65
    },
    restrictions: ['grains', 'sugars', 'most fruits'],
    recommended_recipes: ['2', '4'],
    guru_id: 'guru2',
    duration_weeks: 8
  },
  {
    id: '3',
    name: 'Plant-Based Wellness',
    description: 'Nutrient-rich vegan diet focused on whole foods',
    type: 'vegan',
    daily_targets: {
      calories: 1900,
      protein_percent: 15,
      carbs_percent: 60,
      fat_percent: 25
    },
    restrictions: ['animal products', 'processed foods'],
    recommended_recipes: ['1', '3', '5'],
    guru_id: 'guru3',
    duration_weeks: 16
  },
  {
    id: '4',
    name: 'Diabetic-Friendly',
    description: 'Blood sugar management through balanced nutrition',
    type: 'diabetic',
    daily_targets: {
      calories: 1600,
      protein_percent: 25,
      carbs_percent: 45,
      fat_percent: 30
    },
    restrictions: ['refined sugars', 'white flour', 'sweetened beverages'],
    recommended_recipes: ['2', '4'],
    guru_id: 'guru1',
    duration_weeks: 12
  },
  {
    id: '5',
    name: 'Paleo Performance',
    description: 'Hunter-gatherer inspired diet for optimal health',
    type: 'paleo',
    daily_targets: {
      calories: 2200,
      protein_percent: 30,
      carbs_percent: 30,
      fat_percent: 40
    },
    restrictions: ['grains', 'legumes', 'dairy', 'processed foods'],
    recommended_recipes: ['2', '4'],
    guru_id: 'guru2',
    duration_weeks: 10
  }
]; 